<template>
  <v-dialog 
    v-model="navigation.CRMWhatsappInvoiceDialogIsVisible" 
    @update:model-value="navigation.CRMWhatsappInvoiceDialogIsVisible == false ? closeCRMWhatsappInvoiceDialog() : null" 
    @contextmenu.prevent="null"
    max-width="80vw" 
  >
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-invoice-text</v-icon>
            <template v-if="navigation.CRMWhatsappInvoiceID.length > 1">
              <h3>ORDENES</h3>
            </template>
            <template v-else>
              <h3>ORDEN ({{ navigation.CRMWhatsappInvoiceID[0] }})</h3>
            </template>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="closeCRMWhatsappInvoiceDialog()"
              :disabled="loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialog"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>
      <div style="flex: 1; overflow-y: auto;">
        <template v-if="display.CRMWhatsappInvoices.length > 0">
          <div class="dataContainer">
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-barcode</v-icon>
                <p><strong>ID del contacto: </strong>{{ display.CRMWhatsappInvoices[0].CRMWhatsappContactID }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-account</v-icon>
                <p><strong>Nombre: </strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(display.CRMWhatsappInvoices[0]) }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-phone</v-icon>
                <p><strong>Teléfono: </strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(display.CRMWhatsappInvoices[0].CRMWhatsappContactPhoneNumber) }}</p>
              </div>
            </div>
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-card-account-details</v-icon>
                <p><strong>SSN: </strong>{{ display.CRMWhatsappInvoices[0].CRMWhatsappContactSSN || 'No registrado' }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-email</v-icon>
                <p><strong>Correo electrónico: </strong>{{ display.CRMWhatsappInvoices[0].CRMWhatsappContactEmail || 'No registrado' }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-store</v-icon>
                <p style="margin-right: 5px;"><strong>Localidad del contacto: </strong></p>
                <template v-if="display.CRMWhatsappInvoices[0].CRMWhatsappContactCRMLocalityID && systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappInvoices[0].CRMWhatsappContactCRMLocalityID)">
                  <v-chip :color="systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappInvoices[0].CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                    <p>{{ systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappInvoices[0].CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <p>No registrada</p>
                  </v-chip>
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-for="CRMWhatsappInvoiceID in navigation.CRMWhatsappInvoiceID" :key="CRMWhatsappInvoiceID">
          <template v-if="display.CRMWhatsappInvoices.find(CRMWhatsappInvoice => CRMWhatsappInvoice.CRMWhatsappInvoiceID == CRMWhatsappInvoiceID) && display.CRMWhatsappInvoices.find(CRMWhatsappInvoice => CRMWhatsappInvoice.CRMWhatsappInvoiceID == CRMWhatsappInvoiceID).CRMWhatsappInvoiceProducts && display.CRMWhatsappInvoices.find(CRMWhatsappInvoice => CRMWhatsappInvoice.CRMWhatsappInvoiceID == CRMWhatsappInvoiceID).CRMWhatsappInvoiceProducts.length > 0">
            <template v-if="display.CRMWhatsappInvoices.length > 1">
              <div style="display: flex; gap: 5px; align-items: center; padding: 15px;">
                <v-icon color="indigo">mdi-barcode</v-icon>
                <p><strong>ID de la orden: </strong>{{ CRMWhatsappInvoiceID }}</p>
              </div>
            </template>
            <template v-else>
              <div style="margin-top: 15px;"></div>
            </template>
            <v-card color="borderInner" elevation="0" rounded="0" style="width: 100%; height: 1px;"></v-card>
            <v-data-table
              :headers="display.CRMWhatsappInvoiceProductHeaders"
              :items="display.CRMWhatsappInvoices.find(CRMWhatsappInvoice => CRMWhatsappInvoice.CRMWhatsappInvoiceID == CRMWhatsappInvoiceID).CRMWhatsappInvoiceProducts"
              :items-per-page="-1"
              density="compact"
              fixed-header
              hover
            >
              <template v-slot:header.CRMWhatsappInvoiceProductProductID>
                <div style="display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                  <v-icon color="indigo">mdi-package</v-icon>
                  <p><strong>PRODUCTO</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceProductPrice>
                <div style="display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                  <v-icon color="indigo">mdi-cash</v-icon>
                  <p><strong>PRECIO</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceProductAmount>
                <div style="display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                  <v-icon color="indigo">mdi-numeric</v-icon>
                  <p><strong>CANTIDAD</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceProductSubtotal>
                <div style="display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                  <v-icon color="indigo">mdi-equal</v-icon>
                  <p><strong>SUBTOTAL</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceProductDiscountMargin>
                <div style="display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                  <v-icon color="indigo">mdi-percent</v-icon>
                  <p><strong>DESCUENTO</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceProductDiscountAmount>
                <div style="display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                  <v-icon color="indigo">mdi-cash</v-icon>
                  <p><strong>MONTO DE DESCUENTO</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceProductTotal>
                <div style="display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                  <v-icon color="indigo">mdi-equal</v-icon>
                  <p><strong>TOTAL</strong></p>
                </div>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceProductProductID="{ item }">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <img 
                    :src="item.CRMWhatsappInvoiceProductImageURL || require('@/assets/images/ProductPicturePlaceholder.png')"
                    @click="$root.dialogComponent.openMediaDialog(item.CRMWhatsappInvoiceProductImageURL, item.CRMWhatsappInvoiceProductName, 'webp')"
                    draggable="false" 
                    class="hoverableElement"
                    style="width: 30px; height: 30px; object-fit: cover; border-radius: 50%; border: 2px solid #3F51B5;"
                  >
                  <div style="white-space: nowrap;">
                    <p>{{ item.CRMWhatsappInvoiceProductName }}</p>
                    <p style="font-size: small; color: #9e9e9e;">{{ item.CRMWhatsappInvoiceProductProductID }}</p>
                  </div>
                </div>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceProductPrice="{ item }">
                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(item.CRMWhatsappInvoiceProductPrice) }}</p>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceProductAmount="{ item }">
                <p>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(item.CRMWhatsappInvoiceProductAmount) }}</p>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceProductDiscountMargin="{ item }">
                <p>{{ $displayFunctions.default.parseAmountToDisplay(item.CRMWhatsappInvoiceProductDiscountMargin) }} <span style="color: #3F51B5; margin-left: 5px;"><strong>%</strong></span></p>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceProductDiscountAmount="{ item }">
                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(Math.round(item.CRMWhatsappInvoiceProductPrice * item.CRMWhatsappInvoiceProductAmount * item.CRMWhatsappInvoiceProductDiscountMargin / 100 / 5) * 5) }}</p>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceProductSubtotal="{ item }">
                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(item.CRMWhatsappInvoiceProductPrice * item.CRMWhatsappInvoiceProductAmount) }}</p>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceProductTotal="{ item }">
                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(Math.round(item.CRMWhatsappInvoiceProductPrice * item.CRMWhatsappInvoiceProductAmount * (1 - item.CRMWhatsappInvoiceProductDiscountMargin / 100) / 5) * 5) }}</p>
              </template>
              <template v-slot:bottom></template>
            </v-data-table>
            <v-card color="borderInner" elevation="0" rounded="0" style="width: 100%; height: 1px;"></v-card>
          </template>
        </template>
        <template v-if="display.CRMWhatsappInvoices.length > 0">
          <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
          <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
            <div class="summaryContainer">
              <div style="display: flex; flex-direction: column; gap: 5px;">
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo">mdi-numeric</v-icon>
                  <p><strong>Unidades: </strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMWhatsappInvoices.reduce((CRMWhatsappInvoiceProductAmount, CRMWhatsappInvoice) => CRMWhatsappInvoiceProductAmount + CRMWhatsappInvoice.CRMWhatsappInvoiceProducts.reduce((CRMWhatsappInvoiceProductAmount, CRMWhatsappInvoiceProduct) => CRMWhatsappInvoiceProductAmount + CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductAmount, 0), 0)) }}</p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo">mdi-cash</v-icon>
                  <p><strong>Subtotal: </strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(display.CRMWhatsappInvoices.reduce((CRMWhatsappInvoiceProductAmount, CRMWhatsappInvoice) => CRMWhatsappInvoiceProductAmount + CRMWhatsappInvoice.CRMWhatsappInvoiceProducts.reduce((CRMWhatsappInvoiceProductSubtotal, CRMWhatsappInvoiceProduct) => CRMWhatsappInvoiceProductSubtotal + CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductPrice * CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductAmount, 0), 0)) }}</p>
                </div>
              </div>
              <div class="totalContainer" style="display: flex; flex-direction: column; gap: 5px;">
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo">mdi-percent</v-icon>
                  <p><strong>Descuento: </strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round(display.CRMWhatsappInvoices.reduce((CRMWhatsappInvoiceProductAmount, CRMWhatsappInvoice) => CRMWhatsappInvoiceProductAmount + CRMWhatsappInvoice.CRMWhatsappInvoiceProducts.reduce((CRMWhatsappInvoiceProductDiscount, CRMWhatsappInvoiceProduct) => CRMWhatsappInvoiceProductDiscount + CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductPrice * CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductAmount * CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductDiscountMargin / 100, 0), 0) / 5) * 5) }}</p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo">mdi-cash</v-icon>
                  <p><strong>TOTAL: </strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round(display.CRMWhatsappInvoices.reduce((CRMWhatsappInvoiceProductAmount, CRMWhatsappInvoice) => CRMWhatsappInvoiceProductAmount + CRMWhatsappInvoice.CRMWhatsappInvoiceProducts.reduce((CRMWhatsappInvoiceProductTotal, CRMWhatsappInvoiceProduct) => CRMWhatsappInvoiceProductTotal + CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductPrice * CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductAmount * (1 - CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductDiscountMargin / 100), 0), 0) / 5) * 5) }}</p>
                </div>
              </div>
            </div>
          </v-card>
        </template>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
 .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  .titleContainer {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
  .dataContainer {
    padding: 15px 15px 0px 15px;
    gap: 10px;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(2, 1fr);
  }
  .summaryContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    align-items: center;
    gap: 5px;
  }
  .totalContainer {
    align-items: end;
  }

  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .actionsContainer {
      justify-content: center;
      margin-left: 0;
    }
    .dataContainer {
      grid-template-columns: repeat(1, 1fr);
    }
    .summaryContainer {
      grid-template-columns: repeat(1, 1fr);
    }
    .totalContainer {
      align-items: start;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input: {},
      display: 
      {
        CRMWhatsappInvoices: [],
        CRMWhatsappInvoiceProductHeaders: 
        [
          {title: 'PRODUCTO', key: 'CRMWhatsappInvoiceProductProductID', sortable: false},
          {title: 'PRECIO', key: 'CRMWhatsappInvoiceProductPrice', sortable: false},
          {title: 'CANTIDAD', key: 'CRMWhatsappInvoiceProductAmount', sortable: false},
          {title: 'SUBTOTAL', key: 'CRMWhatsappInvoiceProductSubtotal', sortable: false},
          {title: 'DESCUENTO PORCENTUAL', key: 'CRMWhatsappInvoiceProductDiscountMargin', sortable: false},
          {title: 'MONTO DE DESCUENTO', key: 'CRMWhatsappInvoiceProductDiscountAmount', sortable: false},
          {title: 'TOTAL', key: 'CRMWhatsappInvoiceProductTotal', sortable: false}
        ]
      },
      navigation: 
      {
        CRMWhatsappInvoiceDialogIsVisible: false,
        CRMWhatsappInvoiceID: []
      },
      loader: 
      {
        selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialog: false
      },
      assets: {},
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMLocalities: [],
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {
      async selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialog(){
        const selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappInvoiceID': this.navigation.CRMWhatsappInvoiceID
        };
        const selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappInvoice/functions/selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialog', selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialogRequestQuery);
        if (selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialogResult.success){
          this.loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialog = false;
          this.display.CRMWhatsappInvoices = selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialogResult.result;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar la orden de compra, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappInvoiceDialog();
        }
      },

      async getSystemInformation(){
        this.loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialog = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappInvoiceDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeCRMWhatsappInvoiceDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappInvoiceDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappInvoiceDialog();
        }
      },
      
      async openCRMWhatsappInvoiceDialog(CRMWhatsappInvoiceID){
        this.navigation.CRMWhatsappInvoiceDialogIsVisible = true;
        this.navigation.CRMWhatsappInvoiceID = CRMWhatsappInvoiceID;
        await this.getSystemInformation();
        await this.selectCRMWhatsappInvoiceFromCRMWhatsappInvoiceDialog();
      },

      closeCRMWhatsappInvoiceDialog(){
        this.navigation.CRMWhatsappInvoiceDialogIsVisible = false;
        if (this.systemInformationData.updateSubscription) systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
        this.$emit('closeCRMWhatsappInvoiceDialog');
      }
    }
  }
</script>